module.exports = __webpack_public_path__ + "static/img/1.50931b7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/3/1/1.png
// module id = +unB
// module chunks = 0